import React, { type FC } from "react";
import { withPrefix } from "@tracking/tracking";
import { useTrackElement } from "@edreamsodigeo/frontend-core";

import type { TrackingGoogleButtonProps } from "./contract";

export const ACTION_ID = "_click:google";
export const getTrackingComponentId = (name: string): string =>
  withPrefix("google-click-tracking-component-empty", name);
export const getTrackingUserSelectionBtnId = (name: string): string =>
  withPrefix("tracking-google-user-selection-btn", name);
export const getTrackingMutationSuccessBtnId = (name: string): string =>
  withPrefix("tracking-google-mutation-success-btn", name);
export const getTrackingMutationErrorBtnId = (name: string): string =>
  withPrefix("tracking-google-mutation-error-btn", name);
export const getTrackingComponentInjectedBtnId = (name: string): string => {
  return withPrefix("tracking-google-injected-btn", name);
};
export const getTrackingGoogleDisplayBtnId = (name: string): string =>
  withPrefix("tracking-google-render-btn", name);

const Component: FC<TrackingGoogleButtonProps> = ({
  screen,
  trackingPrefix,
  name,
}) => {
  const trackId = withPrefix(screen || "", trackingPrefix);
  const clickTrackingRef = useTrackElement(["click"], trackId + ACTION_ID);
  const clickTrackingUserSelectionBtnRef = useTrackElement(
    ["click"],
    `${trackId}_account-selection:googleButton`,
  );
  const clickTrackingSucessBtnRef = useTrackElement(
    ["click"],
    `${trackId}_success:googleButton`,
  );
  const clickTrackingErrorBtnRef = useTrackElement(
    ["click"],
    `${trackId}_error:googleButton`,
  );
  const clickTrackingInjectedBtnRef = useTrackElement(
    ["click"],
    `${trackId}_component_injected:googleButton`,
  );
  const clickTrackingDisplayBtnRef = useTrackElement(
    ["click"],
    `${trackId}_render:googleButton`,
  );

  const trackingComponentId = getTrackingComponentId(name);
  const trackingUserSelectionBtnId = getTrackingUserSelectionBtnId(name);
  const trackingMutationSuccessBtnId = getTrackingMutationSuccessBtnId(name);
  const trackingMutationErrorBtnId = getTrackingMutationErrorBtnId(name);
  const trackingComponentInjectedId = getTrackingComponentInjectedBtnId(name);
  const trackingGoogleDisplayBtnId = getTrackingGoogleDisplayBtnId(name);

  return (
    <>
      <div id={trackingComponentId} ref={clickTrackingRef} />
      <div
        ref={clickTrackingUserSelectionBtnRef}
        id={trackingUserSelectionBtnId}
      />
      <div ref={clickTrackingSucessBtnRef} id={trackingMutationSuccessBtnId} />
      <div ref={clickTrackingErrorBtnRef} id={trackingMutationErrorBtnId} />
      <div ref={clickTrackingInjectedBtnRef} id={trackingComponentInjectedId} />
      <div ref={clickTrackingDisplayBtnRef} id={trackingGoogleDisplayBtnId} />
    </>
  );
};
export default Component;
